import script from "./AddProject.vue?vue&type=script&setup=true&lang=js"
export * from "./AddProject.vue?vue&type=script&setup=true&lang=js"

import "./AddProject.vue?vue&type=style&index=0&id=73c6d2ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c6d2ab"]])

export default __exports__